import { render, staticRenderFns } from "./TableIcon.vue?vue&type=template&id=395500e0&"
import script from "./TableIcon.vue?vue&type=script&lang=ts&"
export * from "./TableIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports